import { render } from "./Prenotazioni.vue?vue&type=template&id=431adee3"
import script from "./Prenotazioni.vue?vue&type=script&lang=js"
export * from "./Prenotazioni.vue?vue&type=script&lang=js"
script.render = render

export default script